import { CORP_DEUNGI_OPEN_STATE } from "./enum";

export const getCorpDeungiOpenState = (state: CORP_DEUNGI_OPEN_STATE, type: "watch" | "list") => {
    switch (state) {
        case CORP_DEUNGI_OPEN_STATE.WAITING:
            if (type === "watch") return "등기열람을<br/><span>시작</span>할게요";
            else return "등기열람을 시작할게요";
        case CORP_DEUNGI_OPEN_STATE.SEARCHING:
            if (type === "watch") return "대기열에 등기열람을<br/><span>등록</span>하고 있어요";
            else return "대기열에 등기열람을 등록하고 있어요";
        case CORP_DEUNGI_OPEN_STATE.PAYMENT_ING:
            if (type === "watch") return "인터넷 등기소에서<br/><span>결제진행</span>하고 있어요";
            else return "인터넷 등기소에서 결제진행하고 있어요";
        case CORP_DEUNGI_OPEN_STATE.UPLOAD_ING:
            if (type === "watch") return "등기를<br/><span>업로드 중</span>이에요";
            else return "등기를 업로드 중이에요";
        case CORP_DEUNGI_OPEN_STATE.UPLOAD_DONE:
            if (type === "watch") return "등기열람 준비가<br/><span>완료</span>되었습니다";
            else return "등기 열람 준비가 완료되었습니다";
        case CORP_DEUNGI_OPEN_STATE.PAYMENT_FAIL:
        case CORP_DEUNGI_OPEN_STATE.SEARCHING_FAIL:
            if (type === "watch")
                return '등기열람이<br/><span class="danger">실패</span>되었습니다<br/>다시 시도해주시기<br/>바랍니다';
            else return "등기열람이 실패되었습니다<br/>다시 시도해주시기 바랍니다";
        case CORP_DEUNGI_OPEN_STATE.UPLOAD_FAIL:
        case CORP_DEUNGI_OPEN_STATE.ERROR:
            if (type === "watch")
                return '등기열람이<br/><span class="danger">실패</span>되었습니다<br/>고객센터로<br/><span>문의</span>주시기 바랍니다';
            else return "등기열람이 실패되었습니다<br/>고객센터로 문의주시기 바랍니다";
        default:
            return "";
    }
};
